/**
 * oi js config that will store javascript configuration information throught out
 */

var OIJSConfig = function(){};
$.extend(OIJSConfig.prototype,{
    debugMode:false,
    gTrackingEnabled:false,
    gTrackingIds:null, // Array of google analytics property tracking ids
    gCookiePath:null,
    profileId:-1,
    catalogId:0,
    clientId:0,
    mode:null
});

var AddressComponent = function(){
	this.id;
	this.originalVal;
	this.newVal;
}
var Address = function(id){
	this.id = id;
	this.addressType;
	this.line1 = new AddressComponent();
	this.line2 = new AddressComponent();
	this.city = new AddressComponent();
	this.state = new AddressComponent();
	this.zip = new AddressComponent();
}

var oiCSRFHeaderName = $("meta[name='_csrf_header']").attr("content");
var oiCSRFToken = $("meta[name='_csrf']").attr("content");
var oiCSRFParameter = $("meta[name='_csrf_parameter']").attr("content");
/**
 * determine our current context path
 * @return
 */
function getContextPath()
{
    var pathname = location.pathname;
    return pathname.substring(0,pathname.indexOf("/",1));
}

function addValue(formName, name, value)
{
    var form = document.getElementById(formName);
    addHiddenField(form, name, value);
}

function addHiddenField(form, name, value)
{
    var element = document.createElement("input");
    element.type = "hidden";
    element.name = name;
    element.value = value;
    form.appendChild(element);
}

/**
 * reset the fields hidden in a container so that we don't send answers to the
 * engine when the user changes it's mind
 */
function resetFieldsInHiddenContainers(formId) {
	// disable input fields so they're not submit to the server
	$('#'+formId).find("fieldset:hidden :input").each(function() {
		$(this).val("");
	});

	$('#'+formId).find("div:hidden :input").each(function() {
		$(this).val("");
	});
}

function doSubmit(formId,action,noValidation)
{
	var aForm =$('#'+formId);
	if(action)
	{
		$("input[name='_eventId']",aForm).val(action);
	}
    
	if(noValidation)
	{
		//remove validation event handler
		aForm.validate().cancelSubmit = true;
		resetFieldsInHiddenContainers(formId);
		// Bootstrap 5 vanilla JS: Set button to loading state
		const actionBtn = document.getElementById(action);
		if (actionBtn) {
			actionBtn.disabled = true;
			const originalText = actionBtn.innerHTML;
			actionBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Loading...';
			actionBtn.setAttribute('data-original-text', originalText);
		}
		document.forms[formId].submit(); //this is so the submit handler doesn't get triggered
	} else {
	    aForm.submit();
	}
}

//functions for sending email
function showEmailPlansDialog(selectedObject,planLayout)
{  
  if(planLayout)
  {
    $('#emailRequestForm-layoutType').val(planLayout);
  }
	var planType = (planLayout == 'list') ? "Email Plan List"
			: "Email Plan Compare";
	trackEvent('Tools Used', 'Email Page', 'Started-' + planType);
}

function closeEmailPlansDialog()
{  
  $('#emailErrorMessageArea').html("");
  $('#emailErrorMessageArea').hide();  
	const emailPanelEl = document.getElementById('emailPanel');
	if (emailPanelEl) {
		const modalInstance = bootstrap.Modal.getOrCreateInstance(emailPanelEl);
		modalInstance.hide();
	}
  // Bootstrap 5 vanilla JS: Show/hide elements
  document.getElementById('email_content').style.display = 'block';
  document.getElementById('emailCancelBtn').style.display = 'block';
  document.getElementById('emailSubmitBtn').style.display = 'block';
  document.getElementById('emailHeaderArea').style.display = 'block';
}

function validateEmailRequestForm()
{
  var success = true;
  var emailPattern=/^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+/;
  if(!emailPattern.test($('#emailRequestForm-mailTo').val()))
  {
    $('#emailErrorMessageArea').html("Please enter a valid email address for the To field.");
    $('#emailErrorMessageArea').show();
    $('#emailRequestForm-mailTo').focus();
    success = false;
  } 
  else if(!emailPattern.test($('#emailRequestForm-mailFrom').val()))
  {
    $('#emailErrorMessageArea').html("Please enter a valid email address for the From field.");
    $('#emailErrorMessageArea').show();    
    $('#emailRequestForm-mailFrom').focus();
    success = false;
  } 
  else if($('#emailRequestForm-mailSubject').val() =="")
  {
    $('#emailErrorMessageArea').html("Please enter the subject for this email.");
    $('#emailErrorMessageArea').show();
    $('#emailRequestForm-mailSubject').focus();
    success = false;
  }  

  return success;
}

function submitEmailRequest() {
	// do validation
	if (!validateEmailRequestForm()) {
		return false;
	}
	var planType = ($('#emailRequestForm-layoutType').val() == 'list') ? "Email Plan List"
			: "Email Plan Compare";
	trackEvent('Tools Used', 'Email Page', 'Completed-' + planType);
	$('#email_content').hide();
	$('#email_loading_img').show();
	$.post($("#emailRequestForm").attr("action"), $("#emailRequestForm").serialize(),
		function(data,textStatus)
		{
			$("#emailErrorMessageArea").html("<h2>"+data+"</h2>");	
			$('#emailErrorMessageArea').show();
			$('#email_loading_img').hide();
		});
	// Bootstrap 5 vanilla JS: Hide elements
	document.getElementById('emailCancelBtn').style.display = 'none';
	document.getElementById('emailSubmitBtn').style.display = 'none';
	document.getElementById('emailHeaderArea').style.display = 'none';
}

//function for cost calculator
function doCostCalcUpdate(eventId)
{
	if(eventId)
	{
		$('#_eventId_cost_calc').val(eventId);
	}
	$("#popup_content").append($loading);
	$("#tabs").hide();
	$("#cost_calc_popup_instruction").hide();
	$(".messaging").hide();	
	$.post($("#cost_calc").attr("action"), $("#cost_calc").serialize(),
		function(data,textStatus)
		{
			if(data.indexOf('id="pagecontent"') > -1)
			{
				$("#pagebox").html(data);
				$("#popup_content").dialog("close");
				initOIDoc();
			}
			else
			{
				$("#popup_content").html(data);	
			}
		});
}
function updateCostCalc(aLink,aTitle)
{
	var $dialog = $('#popup_content');
	$dialog.html($loading);
	$dialog.load(aLink.attr('href'))
		.dialog({
			title: aTitle,
			modal: true,
			appendTo: '#pagecontent',
			width:750,
			height:600,		
			close: function(event, ui) {$(this).dialog("destroy");},
			buttons: { "Update": function() {doCostCalcUpdate()}}
		});		
	trackEvent("Tools Used","Cost Calculator",viewId);
}

//print alert message
function doDebug(message)
{
	if((oiConfig) && (oiConfig.debugMode))
	{
		alert(message);
	}    	
}

function disablePageNavigation(){
	if( $('#pnPrevious').hasClass("clicked") ){
		$('#pnPrevious').hide();
		$('#pnPreviousSpinner').show();
		$('#pnContinue').attr("disabled", "disabled");
		if($('#pnSaveForLater').length){
		    $('#pnSaveForLater').attr("disabled", "disabled");
		}
	}else if( $('#pnAlternate').hasClass("quickQuoteBtn") && $('#pnAlternate').hasClass("clicked") ){
		$('#pnAlternate').hide();
		$('#pnAlternateSpinner').show();
		$('#pnPrevious').attr("disabled", "disabled");
		$('#pnContinue').attr("disabled", "disabled");
	}else if( $('#pnSaveForLater').hasClass("clicked") ){
		$('#pnSaveForLater').hide();
		$('#pnSaveForLaterSpinner').show();
        $('#pnContinue').attr("disabled", "disabled");
		$('#pnPrevious').attr("disabled", "disabled");
		$('#pnAlternate').attr("disabled", "disabled");
	}else if( !$('#pnPrevious').hasClass("clicked") ){
		$('#pnContinue').hide();
		$('#pnContinueSpinner').show();
		if($('#pnSaveForLater').length){
		    $('#pnSaveForLater').attr("disabled", "disabled");
		}
		$('#pnPrevious').attr("disabled", "disabled");
		$('#pnAlternate').attr("disabled", "disabled");
	}
}

function addClickedClass(element){
	$(element).addClass("clicked");
}

/**
 * used to find the product using an ajax request
 * each caller of this method will provide there own
 * responseHandler 
 * @param formId
 * @param changer
 * @param responseHandler
 */
function doFind(formId,changer,responseHandler)
{
	var row = changer.substring(changer.indexOf('_')+1); 
	row = row.substr(0,row.indexOf('_'));
	var groupVal = $('#proddata_'+row+'_group').val();
	var selectKeyPrefix = "select[id^='prodselect_"+row+"_']";
	var params = {"_eventId":"find", "group": groupVal, "fieldChanger": changer, "prodRow": row};
	$(selectKeyPrefix).each(function () {
		params[$(this).attr('name')] = $(this).val();
	});		
	$.get($("#"+formId).attr("action"),params,responseHandler);				
}
/**
 * handler for when the product is found on the list page
 * @param data
 * @param textStatus
 */
function productFoundListHandler(data,textStatus)
{
	if(data.prodRow)
	{
		var uri = $("#planlist").attr("action");
		$("#proddata_"+data.prodRow+"_price").html(data.price).effect('highlight',null,500);
		$("#proddata_"+data.prodRow+"_id").val(data.id);
		$("#compareItem_"+data.prodRow).val(data.id);
		$("#proddata_"+data.prodRow+"_longdescription").html(data.longDescription);
		//build apply URL
		var urlBuiilder = uri+"&_eventId=add&cartAction=add&productId="+
		data.id+"&c="+data.price+"&i="+data.systemKey+"&n="+data.name;
		$("#proddata_"+data.prodRow+"_applyurl").attr('href',urlBuiilder);
		//build detail URL
		var urlBuiilder2 = uri+"&_eventId=detail&compareItems="+data.id;
		$("#proddata_"+data.prodRow+"_detailurl").attr('href',urlBuiilder2);

		$.each(data.features, function(index, feature) { 
			  if(feature.showOnList)
			  {
				if(!feature.isSelectable){
				  	$("#proddata_"+data.prodRow+"_"+feature.systemKey).html(feature.valShortName);
				}
				else if(feature.systemKey != data.fieldChangerName)
				{
					//if select drop downs available then select the values that match this field
					$("#prodselect_"+data.prodRow+"_"+feature.systemKey).val(feature.valSystemKey);
				}
			  }
		});			
		//build score bar
		var sBar = $("#proddata_"+data.prodRow+"_score_bar");
		if ( sBar.length )
		{
			var num = new Number(data.score);	
			sBar.width(num.toFixed()+'%');
			$("#proddata_"+data.prodRow+"_score_text").html(data.scoreVerbiage);
		}
	}
	else
	{
		alert(data.message);
	}
}

/**
 * custom validation rules
 */

jQuery.validator.addMethod("validateDateRange", function(value, element) {
	if($.trim(value).length < 1){return true;};//don't validate unless we have a value
    var startDateId =element.attributes['startDate'].value;
    var endDateId =element.attributes['endDate'].value;


    var startDate = new Date($("#"+startDateId).val());
    var endDate = new Date($("#"+endDateId).val());
    var currentDate =  new Date(value);
    var validDate = false;
    if((currentDate > startDate) && (currentDate < endDate)){
        validDate = true;
    }
    else {
      validDate = false;
    }
	return validDate;},
    "Date is not in the valid range. ");



jQuery.validator.addMethod("validateDateAfter", function(value, element) {
        if ( (value == "__/__/____") || (value == "  /  /    ") || (value == "" )){return true;}

        var compareToDateId =element.attributes['compareToDate'].value;
        if (element.id.indexOf('-') > 0) {
            var indexOf = element.id.lastIndexOf('-');
            var appendValue= element.id.substring(indexOf+1, element.id.length);
            compareToDateId = compareToDateId+'-'+appendValue;
        }

        var ele = document.getElementById(compareToDateId);

        if ( (ele.value == null) || (ele.value == "__/__/____") || (ele.value == "  /  /    ") || (ele.value == "" )){return true;}


        var compareToDate = new Date(ele.value);
        var currentDate =  new Date(value);

        var validDate = false;
        if(currentDate > compareToDate){
            validDate = true;
        }
        return validDate;},
function(value, element) {
return element.attributes['message'].value;});




jQuery.validator.addMethod("validateDateBefore", function(value, element) {
        if ( (value == "__/__/____") || (value == "  /  /    ") || (value == "" )){return true;}

        var compareToDateId = element.attributes['compareToDate'].value;
        if (element.id.indexOf('-') > 0) {
            var indexOf = element.id.lastIndexOf('-');
            var appendValue= element.id.substring(indexOf+1, element.id.length);
            compareToDateId = compareToDateId+'-'+appendValue;
        }

        var ele = document.getElementById(compareToDateId);
        if ( (ele.value == null) || (ele.value == "__/__/____") || (ele.value == "  /  /    ") || (ele.value == "" )){return true;}


        var compareToDate = new Date(ele.value);
        var currentDate =  new Date(value);

        var validDate = false;
        if(currentDate < compareToDate){
            validDate = true;
        }

        return validDate;},
    function(value, element) {
        return element.attributes['message'].value;});


jQuery.validator.addMethod("validateDateGreaterThanEqualTo", function(value, element, param) {
    if ( (value == "__/__/____") || (value == "  /  /    ") || (value == "" )){return true;}

    var compareToDate = new Date(param);
    var currentDate =  new Date(value);

    var validDate = false;
    if(currentDate >= compareToDate){
        validDate = true;
    }

    return validDate;},"Date must be greater than or equal to '{0}'");

jQuery.validator.addMethod("validateDateLessThanEqualTo", function(value, element, param) {
    if ( (value == "__/__/____") || (value == "  /  /    ") || (value == "" )){return true;}

    var compareToDate = new Date(param);
    var currentDate =  new Date(value);

    var validDate = false;
    if(currentDate <= compareToDate){
        validDate = true;
    }

    return validDate;},"Date must be less than or equal to '{0}'");

jQuery.validator.addMethod("validateDateLessThanToday", function(value, element) {
	if ( (value == "__/__/____") || (value == "  /  /    ") || (value == "" )){return true;};//don't validate unless we have a value
    return new Date() > new Date(value);
   }, "Date must be less than or equal to the current day.");

jQuery.validator.addMethod("validateDateGreaterThanToday", function(value, element) {
	if ( (value == "__/__/____") || (value == "  /  /    ") || (value == "" )){return true;};//don't validate unless we have a value
    return new Date() < new Date(value);
   }, "Date must be greater than the current day.");

jQuery.validator.addMethod("validateDateEqualToday", function(value, element) {
	if ( (value == "__/__/____") || (value == "  /  /    ") || (value == "" )){return true;};//don't validate unless we have a value
    return new Date().getTime() != new Date(value).getTime();
   }, "Date must equal the current day.");

jQuery.validator.addMethod("validateDateFirstOfMonth", function(value) {
	if ( (value == "__/__/____") || (value == "  /  /    ") || (value == "" )){return true;};//don't validate unless we have a value
    var dayOfMonth = value.substr(3, 2);
    return dayOfMonth === '01';
   }, "Coverage must begin on the first of the month.");

jQuery.validator.addMethod("greaterOrEqual", function(value,element,param) {
	value = value.replace(/\,/g, '');
	return Number(value) >= Number(param);
}, "Please enter a value greater than or equal to {0}.");

jQuery.validator.addMethod("lessOrEqual", function(value,element,param) {
	value = value.replace(/\,/g, '');
	return Number(value) <= Number(param);
}, "Please enter a value less than or equal to {0}");

jQuery.validator.addMethod('money', function(value, element) {
    return this.optional(element) || /^[-0-9,]+(\.\d{2})$/.test(value);
}, "Please enter a valid amount format #.##");

jQuery.validator.addMethod("validName", function(value, element){
	var re = /^$|^[^0-9\$%\^&\(\)_\+=<>.?\";\[\{\}\]@!]+$/;
	return re.test(value);
	}, "Invalid name."
);

jQuery.validator.addMethod("employerNameValid", function(value, element){
	var re = /^[a-zA-Z0-9\s_.@\-!"#$%&'()*+,\\/=?^`|~:,[\]]*$/;
	return re.test(value);
	}, "Invalid name."
);

jQuery.validator.addMethod("apiSafeName", function(value, element){
	var re = /^$|^[^0-9\$%\^&\(\)_\-\+=<>?\";\[\{\}\]@!]+$/;
	return re.test(value);
	}, "Invalid character."
);

jQuery.validator.addMethod("apiSafeName", function(value, element){
	var re = /^$|^[^0-9\$%\^&\(\)_\+=<>?\";\[\{\}\]@!]+$/;
	return re.test(value);
	}, "Invalid character."
);

jQuery.validator.addMethod("lettershyphenonly",function(value, element){
	return this.optional(element)||/^[a-z\-]+$/i.test(value)
}, jQuery.validator.format("Letters/hyphens only please"));

jQuery.validator.addMethod("noSpecialCharsOrNumbers",function(value, element){
	return this.optional(element)||/^[a-zA-Z\-.'\s]+$/i.test(value)
}, jQuery.validator.format("No special characters or numbers"));

jQuery.validator.addMethod("apiSafeAddress", function(value, element){
	var re = /^$|^[^\$%\^&\(\)_\+=<>?\";\[\{\}\]@!]+$/;
	return re.test(value);
	}, "Invalid character."
);

jQuery.validator.addMethod("noPOBoxes", function(value, element){
    var poBoxPattern = /\b(?:p\s*\.?\s*o\s*\.?\s*box|post\s*office\s*box|pobox)\b/i;
    return !poBoxPattern.test(value);
}, "Please do not use PO boxes as home address.");

jQuery.validator.addMethod("apiSafeEmail", function(value, element){
    if(value == '') {
        return true;
    }

    var emailReg = /^(?![\._\-])([\w.-]*[a-zA-Z0-9])@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,4}$/;
    var repeatSpecialChars = /([-_.])\1/;
	return emailReg.test(value) && !repeatSpecialChars.test(value);
	}, "Invalid email."
);

jQuery.validator.addMethod("apiSafeEmail2", function(value, element){
    if(value == '') {
        return true;
    }

    var emailReg = /^(?![\._\-])([\w.-]*[a-zA-Z0-9])@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,4}$/;
    var repeatSpecialChars = /([-_.])\1/;
	var repeatTopLevelDomain = /\.([a-z]{2,})(?:\.\1)+$/i;
	return emailReg.test(value) && !repeatSpecialChars.test(value) && !repeatTopLevelDomain.test(value);
	}, "Please enter a valid email address."
);

jQuery.validator.addMethod("apiSafePhone", function(value, element) {
    value = value.replace(/[()\- ]/g,'');
    if(value == '') {
        return true;
    }

    var phoneReg = /^(?!^(\d)\1{9}$)(?=^[^01]\d{2}[^01])\d{10}$/;

	return phoneReg.test(value);
	}, "Invalid phone number."
);

jQuery.validator.addMethod("alienNumber", function(value, element) {
    value = value.replace(/[()\- ]/g,'');
    if(value == '') {
        return true;
    }

    var alienNumberReg = /^A(?!(\d)\1{8})\d{9}$/;

	return alienNumberReg.test(value);
	}, "Invalid alien number."
);

jQuery.validator.addMethod("bannedForeignAreaCodes", function(value, element) {
    value = value.replace(/[()\- ]/g,'');
    if(value == '') {
        return true;
    }

    var bannedAreaCodes = [204, 226, 236, 242, 246, 249, 250, 263, 264, 268, 284, 289, 306, 343, 345, 354, 365, 367, 368, 382, 403, 416, 418, 428, 431, 437, 438, 441, 450, 468, 473, 474, 506, 514, 519, 548, 579, 581, 584, 587, 604, 613, 639, 647, 649, 664, 672, 683, 705, 709, 721, 742, 743, 753, 758, 767, 778, 780, 782, 784, 807, 809, 819, 825, 829, 849, 867, 868, 869, 873, 876, 879, 902, 905];
    var validAreaCode = true;
    for(let i=0; i < bannedAreaCodes.length; i++) {
        if(value.startsWith(bannedAreaCodes[i])) {
            validAreaCode = false;
        }
    }

	return validAreaCode;
	}, "Invalid phone number."
);

jQuery.validator.addMethod("apiSafeOneLetter", function(value, element){
    var letterReg = /^$|\s+|[a-zA-Z]{1}/;
	return letterReg.test(value);
	}, "Must contain at least one meaningful letter."
);

jQuery.validator.addMethod("apiSafeOneCharacter", function(value, element){
    var charReg = /^$|\s+|[a-zA-Z0-9]{1}/;
	return charReg.test(value);
	}, "Must contain at least one meaningful letter or number."
);

jQuery.validator.addMethod(
	"apiSafeEmployerIdNumber",
	function (value, element) {
	    if (jQuery.trim(value) == "") { return true; }  //don't validate unless we have a value
		var re = /^\d{9}$/;
		return re.test(value);
	},
	"Invalid. Must be 9 digits."
);

jQuery.validator.addMethod("ssnInput", function(value,element) {
	if(value == "___-__-____"){return true;};
	if (jQuery.trim(value) == "") { return true; }  //don't validate unless we have a value
    var ssn = /\b(?!\b(\d)[^1]\1+[ -]?(\d)\1+[ -]?(\d)\1+\b)(?!123-45-6789|123456789)(?!000)(?!666)(?!9)[0-9]{3}[ -]?(?!00)[0-9]{2}[ -]?(?!0000)[0-9]{4}\b/;
    var itin = /\b9\d{2}[ -]?((7\d|8[0-8])|(9([0-2]|[4-9])))[ -]?\d{4}\b/;
    return ssn.test(value) || itin.test(value);
    }, "Must be a valid Social Security Number."
);

jQuery.validator.addMethod("npnInput", function(value,element) {
   	if(value == "___-__-____"){return true;};
   	if (jQuery.trim(value) == "") { return true; }  //don't validate unless we have a value
   	  var npn = /\b(?!\b(\d)[^1]\1+[ -]?(\d)\1+[ -]?(\d)\1+\b)(?!123-45-6789|123456789)(?!000)(?!666)(?!9)[0-9]{3}[ -]?(?!00)[0-9]{2}[ -]?(?!0000)[0-9]{4}\b/;
      return npn.test(value);
    }, "Must be a valid National Produce Number."
);

jQuery.validator.addMethod("medicareCodeInput", function(value,element) {
	var minLength = 7;
	var length = value.replace(/-/g,'').replace(/_/g,'').length;
	if( (value == "___-__-____-_") || (jQuery.trim(value) == "") ){ return true; };
	return (length > minLength) || (minLength == length);
	}, "Medicare number must be at least 7 characters."
);

jQuery.validator.addMethod("validZip", function(value,element) {
		if(value != null){
			var stateId = $(element).attr('stateId');
			zipCodeValidator(value, "#"+stateId);
			return true;
		} else{ return false};
	}, "Must be a valid Zip Code."
);

jQuery.validator.addMethod("validSic", function(value, element) {
    var validator = this;
    var previous = this.previousValue(element);

    // Clear previous validation message first
    validator.errorsFor(element).remove();

    if (!value) {
        return false;
    }

    // If we already validated this value, return the previous result
    if (previous.old === value) {
        return previous.valid;
    }

    // Mark as pending
    this.startRequest(element);

    sicCodeValidator(value).then(result => {
        previous.valid = result;
        previous.old = value;

        // Remove pending state
        validator.stopRequest(element, result);

        // Force revalidation immediately
        if (!result) {
            $(element).valid();
        }
    });

    // Return true initially to avoid triggering false validation message on correct field.
    return true;
}, "Must be a valid SIC Code.");

function basicZipStrTest(zipStr) {
	zipStr = String(zipStr).trim();
	if (!zipStr) {
		return false
	}
	const firstPart = zipStr.slice(0,5)
	const zipRegex = /^\d{5}(-\d{4})?$/;
	return zipRegex.test(zipStr)
		&& Number(firstPart) > 500		// the lowest zip code is 00501
		&& Number(firstPart) <= 99950; // the highest zip code is 99950
}

jQuery.validator.addMethod("zipInput", function(value,element) {
		if (jQuery.trim(value) === "") { return true; }  //don't validate unless we have a value
		return basicZipStrTest(value)
	}, "Please enter a valid ZIP code."
);

jQuery.validator.addMethod("zipInputPlus4", function(value,element) {
		if (jQuery.trim(value) === "") { return true; }  //don't validate unless we have a value
		return basicZipStrTest(value)
	}, "Please enter a valid ZIP code."
);

jQuery.validator.addMethod("phoneInput", $.validator.methods.phoneUS, "Please specify a valid phone number");

jQuery.validator.addMethod("urlInput", $.validator.methods.url, "Please enter a valid URL. Ex: https://example.com");

jQuery.validator.addMethod('stateInput', function(value) {
	if (jQuery.trim(value) == "") { return true; }  //don't validate unless we have a value
	var valid = ["AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN","IA","KS",
				 "KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC",
				 "ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];
	return valid.indexOf(value) > -1;
}, 'Please enter a valid 2 letter state code.');

jQuery.validator.addMethod("validPolicyNumber", function(value,element) {
	if (jQuery.trim(value) == "") { return true; }  //don't validate unless we have a value
	  var re = /^[a-zA-Z0-9\-]*$/;
    return re.test(value);
    }, "Invalid Character"
);
//Use this method (that is, assign class="dateInput" to override the default Date
//validator.  IE (up to v9) incorrectly allows values up to 69 in month and day
//fields.
jQuery.validator.addMethod("dateInput", function(value,element) {
	if ( (value == "__/__/____") || (value == "  /  /    ") || (value == "" )){return true;};//don't validate unless we have a value
	
	// Check if it's ISO format (YYYY/MM/DD) first
	if (/^\d{4}[-/]\d{1,2}[-/]\d{1,2}$/.test(value)) {
		return isValidFormattedDate(value, 'yyyy/mm/dd');
	}
	
	// Otherwise check MM/DD/YYYY format
	return isValidFormattedDate(value, 'mm/dd/yyyy');
	}, "Must be a valid date."
);

jQuery.validator.addMethod("newMedicareCodeInput", function(value,element) {
	if ( (value == "____-___-____") || (value == "    -   -    ") || (value == "" )){return true;};//don't validate unless we have a value
	var exclude = /^1EG4-TE5-MK72$/;
	if (exclude.test(value)) {
		return false;
	}
	var re = /^\d[A-Z]([A-Z]|\d)\d\-[A-Z]([A-Z]|\d)\d\-[A-Z][A-Z]\d\d$/;
	return re.test(value);
	}, "Must be a valid Medicare number."
);

jQuery.validator.addMethod("employmentCardNumber", function(value, element){
	var re = /^[A-Z]{3}\d{10}$/;
    if(value == '') {
        return true;
    }
	return re.test(value);
	}, "Must start with 3 letters and end with 10 numbers."
);

jQuery.validator.addMethod("medicaidCodeInput", function(value,element) {
	if ( (value == "_______") || (value == "       ") || (value == "" )){return true;};//don't validate unless we have a value
	var re = /^[A-Z]\d{6}$/;
	return re.test(value);
	}, "Must be a valid Medicaid number."
);


// test if a value equals another value but the equalTo comes from the element attribute
jQuery.validator.addMethod("validateEqualsTo", function(value, element, param) {
	value = $.trim(value);
	if (!param && value == "") { return true; }
	return  value == param;
}, jQuery.validator.format('Please enter the correct value "{0}"'));

jQuery.validator.addMethod("futureDate", function(value, element) {
	var date = new Date(value);
	var today = new Date();
	return date > today;
}, "Please enter a future date.");

jQuery.validator.addMethod("todayOrFutureDate", function(value, element) {
    if ( (value == "__/__/____") || (value == "  /  /    ") || (value == "" )){return true;};//don't validate unless we have a value
	var date = new Date(value);
	var today = new Date();
	today.setHours(0,0,0,0);
	return date >= today;
}, "Date cannot be in the past.");

jQuery.validator.addMethod("positiveNumber", function(value) {
	value = value.replace(/\,/g, '');
	return Number(value) >= 0;
}, "Please enter a positive number.");

// test if date the format mm/yyyy is a valid expiration date
jQuery.validator.addMethod("expdate", function(value, element) {
	var date = new Date();
	var month = date.getMonth() + 1;
	var year = date.getFullYear();
	var array = value.split("/");
	return (array[1] > year) || (array[1] == year && array[0] >= month);
}, "Please enter a valid expiration date.");

// test if number has 2 or no decimals
jQuery.validator.addMethod('numbermoney', function(value, element) {
	return this.optional(element) || /^[0-9,]+(\.\d{2})?$/.test(value);
}, "Please enter a valid amount.");

//check non zero value
jQuery.validator.addMethod('nonZero', function(value, element) {
    return this.optional(element) || /^-?(?!0*(\.0+)?$)(\d*\.\d+)$/.test(value);
}, "Please enter non zero value.");

// aba routing validation
jQuery.validator.addMethod('abarouting', function(value, element) {
	var n = 0;
	for (var i = 0; i < value.length; i += 3) {
		n += parseInt(value.charAt(i), 10) * 3;
		n += parseInt(value.charAt(i + 1), 10) * 7;
		n += parseInt(value.charAt(i + 2), 10);
	}
	return (n != 0 && n % 10 == 0);
}, "Please enter a valid ABA routing number.");

jQuery.validator.addMethod("require_from_group_oi", function(value, element, options) {
    var validator = this;
    var selector = options[1];
    var validOrNot = $(selector, element.form).filter(function() {
        return validator.elementValue(this);
    }).length >= options[0];

    if(!$(element).data('being_validated')) {
        var fields = $(selector, element.form);
        fields.data('being_validated', true);
        fields.valid();
        $(element.form).valid();
        fields.data('being_validated', false);
    }
    return validOrNot;
}, jQuery.validator.format("Please fill at least {0} of these fields."));

$.validator.addMethod( "phoneInputWExt", function( phone_number, element ) {
    const phoneRegex = /^(?:\+?1[-.\s]?)?(?:\(?([2-9]\d{2})\)?[-.\s]?)?([2-9]\d{2})[-.\s]?(\d{4})(?:(?:ext\.?|x)(\d+))?$/;
    phone_number = phone_number.replace( /_/g, "" ); // Remove unfilled mask placeholders
    phone_number = phone_number.replace( /\s*ext\.?\s*$/g, "" ); // Remove trailing ext. with no digits
	phone_number = phone_number.replace( /\s+/g, "" );
	return this.optional( element ) || phone_number.length > 9 &&
		phoneRegex.test(phone_number);
}, "Please specify a valid phone number." );


//browser compatible date validation
function isValidFormattedDate(date_string, format) {
	var days = [0,31,28,31,30,31,30,31,31,30,31,30,31];
	var year, month, day, date_parts = null;
	var rtrn = false;
	var decisionTree = {
		'm/d/y':{'re':/^(\d{1,2})[./-](\d{1,2})[./-](\d{2}|\d{4})$/,'month': 1,'day': 2, year: 3},
		'mm/dd/yy':{'re':/^(\d{1,2})[./-](\d{1,2})[./-](\d{2})$/,'month': 1,'day': 2, year: 3},
		'mm/dd/yyyy':{'re':/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/,'month': 1,'day': 2, year: 3},
        'y/m/d':{'re':/^(\d{2}|\d{4})[./-](\d{1,2})[./-](\d{1,2})$/,'month': 2,'day': 3, year: 1},
        'yy/mm/dd':{'re':/^(\d{1,2})[./-](\d{1,2})[./-](\d{1,2})$/,'month': 2,'day': 3, year: 1},
        'yyyy/mm/dd':{'re':/^(\d{4})[./-](\d{1,2})[./-](\d{1,2})$/,'month': 2,'day': 3, year: 1}
	};
	var test = decisionTree[format];
	if (test) {
		date_parts = date_string.match(test.re);
		if (date_parts) {
			year = date_parts[test.year] * 1;
			month = date_parts[test.month] * 1;
			day = date_parts[test.day] * 1;
			
			test = (month == 2 && isLeapYear() && 29 || days[month] || 0);
			rtrn = 1 <= day && day <= test;
		}
	}
	
	function isLeapYear() {
		if (year % 400 == 0) { 
			return true;
		}
		else if (year % 100 == 0) {
			return false;
		}
		else if (year % 4 == 0) {
			return true;
		}
	}

	return rtrn;
}


function applyCommonInputMasks(){
	$('.zipInput').inputmask("99999", {showMaskOnHover: false});
	$('.zipInputPlus4').inputmask("99999[-9999]", {showMaskOnHover: false, greedy: false});
	$('.phoneInput').inputmask("(999) 999-9999", {showMaskOnHover: false}).attr('maxlength', 25);
	$('.phoneInputWExt').inputmask("(999) 999-9999 [ext. 9{1,5}]", {showMaskOnHover: false}).attr('maxlength', 30);
	$(".ssnInput").inputmask("999-99-9999", {showMaskOnHover: false}).attr('maxlength', 11);
	$(".dateInput").inputmask("mm/dd/yyyy", {showMaskOnHover: false});
	$('.stateInput').inputmask("AA", {definitions: {"A": {validator: "[a-zA-Z]", casing: "upper"}}});
	$('#taxId').inputmask("99-9999999",{ "placeholder": " " });
}

function toggleCompare(id,theCheckBox)
{
	var labelId = "#compareItems_"+id+"_label";
	var buttonId = "#compareItems_"+id+"_button";
	var isChecked = theCheckBox === undefined ? $('#compareItems_' + id).is(":checked") : theCheckBox.is(":checked");
	
	if(isChecked){
		//hide the label
		$(labelId).hide();
		$("#prodbox_"+id).attr("class","compared box");
		//show the button
		$(buttonId).show();
	} else {
		//show the label 
		$(labelId).show();
		$("#prodbox_"+id).attr("class","box");
		//hide the button
		$(buttonId).hide();
	}
}

/**
 * only allow numbers keydown. attached to keydown event
 * @param e
 * @returns {Boolean}
 */
function internalCheck(code, ch, key, v) {
	var decSeparator =".";//or ","
    if (key==code)
        if (ch==decSeparator) {
                if (v.indexOf(decSeparator)!=-1) 
                    return false;
        } else {
            return false;
        }
    return true;
}

function numberOnly(e){
    var key = e.which || e.keyCode;
    
    if (!e.shiftKey && !e.altKey && !e.ctrlKey &&
    // numbers   
        key >= 48 && key <= 57 ||
    // Numeric keypad
        key >= 96 && key <= 105 ||
    // comma, period and minus, . on keypad      '
       key == 190 || key == 188 || key == 109 || key == 110 || key == 222 ||
    // Backspace and Tab and Enter
       key == 8 || key == 9 || key == 13 ||
    // Home and End
       key == 35 || key == 36 ||
    // left and right arrows
       key == 37 || key == 39 ||
    // Del and Ins
       key == 46 || key == 45) {
       var $that = $(e.target);
        var v=$that.val();
    
        var tmp =internalCheck(190,".",key,v);
        if (!tmp) return false;
        
        var tmp =internalCheck(188,",",key,v);
        if (!tmp) return false;
  
        return true;
    } else if (e.ctrlKey){
        //ctrl-c       ctrl-v       ctrl-x
        if (key==67 || key==86  || key==90)
            return true;
    }
    return false;
}

function addToggleClickListener(element, className) {
	if (!element) {
    	return;
  	}

  	element.addEventListener('click', function(e) {
		e.preventDefault();

		document.querySelectorAll('.' + className + 'Toggle').forEach(function(toggle) {

			const toggleStyle = toggle.style.display === 'none' || !toggle.style.display ? 'block' : 'none';

			toggle.style.display = toggleStyle;
		});

		return false;
	});
}

function setTimeAgo(className, dataAttr) {
    var td = "tbody td." + className;
    var ta = "th." + className + " a";

    $(td).each(function() {
        const timeAgoSpan = $(this).find('span.timeago');
        const timeAgoText = $(this).attr(dataAttr)?.length
            ? $.timeago($(this).attr(dataAttr))
            : "";

        timeAgoSpan.text(timeAgoText);
    });

    document.querySelectorAll(ta).forEach(function(element) {
        addToggleClickListener(element, className);
    });
}

function number_format (number, decimals, dec_point, thousands_sep) {
    // http://kevin.vanzonneveld.net
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     bugfix by: Michael White (http://getsprink.com)
    // +     bugfix by: Benjamin Lupton
    // +     bugfix by: Allan Jensen (http://www.winternet.no)
    // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +     bugfix by: Howard Yeend
    // +    revised by: Luke Smith (http://lucassmith.name)
    // +     bugfix by: Diogo Resende
    // +     bugfix by: Rival
    // +      input by: Kheang Hok Chin (http://www.distantia.ca/)
    // +   improved by: davook
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Jay Klehr
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Amir Habibi (http://www.residence-mixte.com/)
    // +     bugfix by: Brett Zamir (http://brett-zamir.me)
    // +   improved by: Theriault
    // +      input by: Amirouche
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // *     example 1: number_format(1234.56);
    // *     returns 1: '1,235'
    // *     example 2: number_format(1234.56, 2, ',', ' ');
    // *     returns 2: '1 234,56'
    // *     example 3: number_format(1234.5678, 2, '.', '');
    // *     returns 3: '1234.57'
    // *     example 4: number_format(67, 2, ',', '.');
    // *     returns 4: '67,00'
    // *     example 5: number_format(1000);
    // *     returns 5: '1,000'
    // *     example 6: number_format(67.311, 2);
    // *     returns 6: '67.31'
    // *     example 7: number_format(1000.55, 1);
    // *     returns 7: '1,000.6'
    // *     example 8: number_format(67000, 5, ',', '.');
    // *     returns 8: '67.000,00000'
    // *     example 9: number_format(0.9, 0);
    // *     returns 9: '1'
    // *    example 10: number_format('1.20', 2);
    // *    returns 10: '1.20'
    // *    example 11: number_format('1.20', 4);
    // *    returns 11: '1.2000'
    // *    example 12: number_format('1.2000', 3);
    // *    returns 12: '1.200'
    // *    example 13: number_format('1 000,50', 2, '.', ' ');
    // *    returns 13: '100 050.00'
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
} 

function addToHSA(yourAmount,multiplier,elementId){
    //get the values of teh estimates and convert to numbers so we can do math
    var empAmount = parseFloat(getAsNumber($(elementId).text()));
    //convert to numbers so we can do math
    yourAmount = yourAmount == "" ? 0:parseFloat(yourAmount) * multiplier;
    var finalTotal ="$" + number_format(empAmount + yourAmount,2,".",",");  
    return finalTotal;   
}
function calculateFinalTotalWithHSA(fixedCostElementId,outEstimateElementId){
    //get the values of teh estimates
    var outEstimate = parseFloat(getAsNumber($(outEstimateElementId).text()));
    var fixedCost = parseFloat(getAsNumber($(fixedCostElementId).text()));
    //convert to numbers so we can do math
    fixedCost = fixedCost * 12;
    var finalTotal ="$" + number_format(outEstimate + fixedCost,2,".",",");  
    return finalTotal;   
}

function calculateOOPWithHSA(oopEstimateElementId,totalContribElementId){
    //get the values of teh estimates
    var contrib = parseFloat(getAsNumber($(totalContribElementId).text()));
    var outEstimate = parseFloat(getAsNumber($(oopEstimateElementId).text()));
    var finalTotal = outEstimate - contrib;
    if(finalTotal < 0){
    	//we dont have estimate so make premium estimate because when we have estimate it includes annual premium so don't add again
    	finalTotal = 0;
    }
    finalTotal ="$" + number_format(finalTotal,2,".",",");  
    return finalTotal;   
}


/**
 * given a string apply regex to get a number if anything exist
 * @param val
 */
function getAsNumber(val){
	return val.replace(/[^0-9\.]+/g, '')
}

/**
 * jquery validator used to show the error on the top of the page
 * @param e
 * @param validator
 */
function defaultFormErrorHandler(e,validator){
	var errors = validator.numberOfInvalids();
	if (errors) {
		var message = errors == 1
			? getMessage('error.missed_field','You missed 1 field. It has been indicated below.')
			: getMessage('error.missed_fields','You missed ' + errors + ' fields.  They have been indicated below.', [errors]);
		$("#messaging").html('<div class="alert alert-warning alert-dismissible fade show" role="alert"><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button><p>' + message + '</p></div>' );
        $("#messaging").addClass('oldvdError');
	}
	else {
		$("#messaging").removeClass('oldvdError');
	}
}

function showPageMessages(level, messages, messageId){
	var $container = $("#messaging");
	if (!$container.length) {
		return;
	}

	var id = messageId || 'ajaxPageMessage';
	clearPageMessage(id);

	if (!messages) {
		return;
	}

	var list = Array.isArray(messages) ? messages : [messages];
	list = list.filter(function(msg){ return msg !== null && msg !== undefined && String(msg).trim() !== ''; });
	if (!list.length) {
		return;
	}

	var levelClassMap = {
		error: 'danger',
		warning: 'warning',
		info: 'info',
		success: 'success'
	};
	var alertLevel = levelClassMap[level] || 'info';
	var $alert = $('<div class="alert alert-' + alertLevel + ' alert-block alert-dismissible fade show" role="alert"></div>').attr('id', id);
	var $content = $('<div class="container"></div>');
	var $ul = $('<ul></ul>');

	list.forEach(function(msg){
		$('<li></li>').text(msg).appendTo($ul);
	});

	$content.append($ul);
	$content.append('<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>');
	$alert.append($content);
	$container.prepend($alert);
}

function clearPageMessage(messageId){
	var id = messageId || 'ajaxPageMessage';
	$("#" + id).remove();
}

function convertSurveyAddressFieldsToJson(){
	var addressList = [];
	var primaryFound = false;
	$('.validateAddress').each(function(i, val){
		if( $(this).is(":visible") ){
			if($(this).find('.zip').val() !== 'undefined' && $(this).find('.zip').val().length > 0){ //if atleast zip/state is there, then try and validate.
				var address = new Address(i);
				address.line1.id = $(this).find('.line1').attr('id');
				address.line1.originalVal = $(this).find('.line1').val();
				address.line2.id = $(this).find('.line2').attr('id');
				address.line2.originalVal = $(this).find('.line2').val();
				address.city.id = $(this).find('.city').attr('id');
				address.city.originalVal = $(this).find('.city').val();
				address.state.id = $(this).find('.state').attr('id');
				address.state.originalVal = $(this).find('.state').val();
				address.zip.id = $(this).find('.zip').attr('id');
				address.zip.originalVal = $(this).find('.zip').val();

				if(!primaryFound){
					var str = $(this).attr('id');
					if(str.indexOf("homeAddress") != -1){
						address.addressType = "Primary";
						primaryFound = true;
					}
				}
				addressList.push(address);	
			}	
		}	
	});
	return JSON.stringify(addressList);
}

function convertAddressFieldsToJson(){
	var addressList = [];
	var primaryFound = false;
	$('.validateAddress').each(function(i, val){
		if( $(this).is(":visible") ){
			if($(this).find('.zip').val() !== 'undefined' && $(this).find('.zip').val().length > 0){ //if atleast zip/state is there, then try and validate.
				var address = new Address(i);
				address.line1.id = $(this).find('.line1').attr('id');
				address.line1.originalVal = $(this).find('.line1').val();
				address.line2.id = $(this).find('.line2').attr('id');
				address.line2.originalVal = $(this).find('.line2').val();
				address.city.id = $(this).find('.city').attr('id');
				address.city.originalVal = $(this).find('.city').val();
				address.state.id = $(this).find('.state').attr('id');
				address.state.originalVal = $(this).find('.state').val();
				address.zip.id = $(this).find('.zip').attr('id');
				address.zip.originalVal = $(this).find('.zip').val();
				
				if(!primaryFound){
					var str = $(this).attr('id');
					if(str && str.indexOf("homeAddress") != -1){
						address.addressType = "Primary";
						primaryFound = true;
					}
				}
				addressList.push(address);	
			}	
		}	
	});
	return JSON.stringify(addressList);
}

function sicCodeValidator(sic, stateElementId) {
    return new Promise((resolve, reject) => {
        var uri = getContextPath() + "/eapp/sic/search?sic=" + sic;
        $.getJSON(uri, function(data) {
            if (!data || data.length === 0) {
                resolve(false);
            } else {
                resolve(true);
            }
        }).fail(function() {
            resolve(false);
        });
    });
}

function zipCodeValidator(zip, stateElementId){
	var uri = getContextPath()+"/eapp/zipcode?zip="+zip;
	$.getJSON(uri, function(data) {		
		$.each(data, function(i, val) {
				$(stateElementId).val(val.stateAbbreviation);
		});
	});
}

function findZipCode(uri, county, stateSelector) {
  const $zipCodeFields = $('[id*="zip" i]');
  let isZipCodeVisible = false;
  // there should only ever be one zip code, but treat as if there could be multiple and if any of them are visible then we want to trigger the county/state lookup
  $zipCodeFields?.each(function() {
    if ($(this).is(':visible') || isZipCodeVisible) {
      isZipCodeVisible = true;
    }
  });

  // Only trigger if the zipCode field is visible, which means the zip code field is visible.
  if (!isZipCodeVisible)  return;

  // Manually add active class to zip field because the programmatic change won't trigger the event handlers that would normally add the active class
  if ($zipCodeFields.val()?.length > 0) {
      $zipCodeFields.addClass('active');
  }

	$.getJSON(uri, function(data) {
		var stateBefore;
		if (typeof stateSelector !== 'undefined') {
			stateBefore = $(stateSelector).val();
			if(stateBefore == null || stateBefore.length === 0){
				stateBefore = "--";
			}
		}
    $('#county').empty();
    var totalStates = 0;
    var firstState = "";

		$.each(data, function(i, val) {
			if (data.length > 1 && i == 0) {
				$('#county').append($('<option>').text('- Please Select -').attr('value', ''));
			}

			var attributeMap = {value: val.county, state: val.stateAbbreviation};
			if(data.length == 1 || val.county === county){
			   attributeMap["selected"] = "selected";
			}
			$('#county').append($('<option>').text(val.county).attr(attributeMap));

			if(firstState !== val.stateAbbreviation){
			  firstState = val.stateAbbreviation;
			  totalStates++;
			}
		});

		if(data.length > 1){
			$('#countySelector').show();
			$('#county').focus();
			$('#county').rules('add','required');
		} else {
			$('#countySelector').hide();
			$('#county').rules('remove','required');
		}

    if (typeof stateSelector !== 'undefined') {
        // Only fill in state if there's only 1 county or if county is defined
        if(totalStates == 1) {
            $(stateSelector).val(data[0].stateAbbreviation);
			$(stateSelector).addClass('active valid');
        } else {
            //multiple states we need to let the user chose the county
            $(stateSelector).val('');
        }

        if(stateBefore){
            if(stateBefore !== $(stateSelector).val()){
                $('#state').trigger('change');
            }
        }
    }
	});
}

//HTML5 Placeholder in IE and Unsupported Browsers
//Add the following to page .. $.fn.placeholder();
(function($) {
	$.fn.placeholder = function() {
		if (typeof document.createElement("input").placeholder == 'undefined') {
			$('[placeholder]').focus(function() {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
					input.removeClass('placeholder');
				}
			}).blur( function() {
				var input = $(this);
				if (input.val() == '' || input.val() == input.attr('placeholder')) {
					input.addClass('placeholder');
					input.val(input.attr('placeholder'));
				}
			}).blur().parents('form').submit(function() {
				$(this).find('[placeholder]').each(function() {
					var input = $(this);
					if (input.val() == input.attr('placeholder')) 
						input.val('');
				});
			});
		}
	};
})(jQuery);

// change language
function doLang(lang) {
	var url = getContextPath() + '/eapp/localeswitcher?lang=' + lang;
	$.ajax({
		type: "get",
		dataType: "json",
		url: url,
		cache: false,
		success: function(data) {
			// refresh page
			location.reload();
		}
	});
}

// message resource
// issue: local_messages is undefined when getMessage is called from this file
function getMessage(code, text, args) {
	if (typeof local_messages !== 'undefined') {
		var value = local_messages[code];
		if (value !== undefined && args !== undefined) {
			for (var i = 0; i < args.length; i++) {
				value = value.replace('{' + i +'}', args[i]);
			}
		}
		else if (value === undefined) {
			value = text;
		}
		return value;
	}
	return text;
}

// Date Utilities
// Source: http://stackoverflow.com/questions/497790

function str2date(d) {
	// Converts the date in d to a date-object. The input can be:
	//   a date object: returned without modification
	//  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
	//   a number     : Interpreted as number of milliseconds
	//                  since 1 Jan 1970 (a timestamp)
	//   a string     : Any format supported by the javascript engine, like
	//                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
	//  an object     : Interpreted as an object with year, month and date
	//                  attributes.  **NOTE** month is 0-11.
	return (
		d.constructor === Date ? d :
			d.constructor === Array ? new Date(d[0], d[1], d[2]) :
				d.constructor === Number ? new Date(d) :
					d.constructor === String ? new Date(d) :
						typeof d === "object" ? new Date(d.year, d.month, d.date) :
							NaN
	);
}

function cmpDates(a, b) {
	// Compare two dates (could be of any type supported by the convert
	// function above) and returns:
	//  -1 : if a < b
	//   0 : if a = b
	//   1 : if a > b
	// NaN : if a or b is an illegal date
	// NOTE: The code inside isFinite does an assignment (=).
	a=str2date(a).valueOf();
	b=str2date(b).valueOf();
	var result;
	if (isFinite(a) && isFinite(b)) {
		result=(a>b)-(a<b);
	} else {
		result=NaN;
	}
	return result;
}

function injectCsrfTokens() {
  $("form").each(function () {
    var form = $(this);
    var method = form.attr("method");
    if (method && method.toUpperCase() !== "GET") {
      // Always prefer hidden input (works for multipart and non-multipart)
      if (form.find("input[name='" + oiCSRFParameter + "']").length < 1) {
        $("<input>", {
          type: "hidden",
          name: oiCSRFParameter,
          value: oiCSRFToken
        }).appendTo(form);
      }
    }
  });
}

// Add anti-CSRF token to all non-GET AJAX requests (if not already present)
$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
	var isGet = !originalOptions.type || originalOptions.type.toUpperCase() === "GET";
	if(!isGet){
        jqXHR.setRequestHeader(oiCSRFHeaderName, oiCSRFToken);
	}
});